import toPriceDisplay from "./toPriceDisplay";

/**
 * Formata um valor com a gramática do preço do produto: 'A partir de' quando
 * há adicionais obrigatórios e ' Kg' quando o produto é vendido a peso.
 *
 * O 'A partir de' é decidido pelos preços cheios do produto, e não pelo valor
 * passado: subtrair o mesmo desconto dos dois extremos não muda se eles são
 * iguais, e a comparação aqui é de string.
 */
export function productPriceDisplay(product, amount, customSeparator = null) {
  const startFrom = product.maxPrice === product.minPrice ? "" : "A partir de ";
  const unit = product.isKilogram ? " Kg" : "";
  return `${startFrom}${toPriceDisplay(amount, customSeparator)}${unit}`;
}

export default function productUnitPriceDisplay(
  product,
  customSeparator = null,
) {
  return productPriceDisplay(product, product.minPrice, customSeparator);
}
